import Tooltip from "@/component/Tooltip";
import { message } from 'antd';

interface GenerateButtonProps {
  isPrevent?: boolean;
  preventText?: string;
  onSummaryClick?: () => void;
}

const GenerateButton = ({ isPrevent, preventText, onSummaryClick }: GenerateButtonProps) => {
  const handleSummaryClick = () => {
    if (isPrevent) {
      message.warning(preventText);
      return;
    }
    onSummaryClick?.();
  };

  const buttonElement = (
    <div
      className="relative w-30.5 h-9 mt-6 rounded-2.5 cursor-pointer flex items-center justify-center"
      onClick={handleSummaryClick}
      style={{
        background:
          "linear-gradient(white, white) padding-box, linear-gradient(45deg, #4981F2, #9984F7, #CD84F4) border-box",
        border: "1px solid transparent",
      }}
    >
      <span
        className="text-sm font-medium"
        style={{
          background: "linear-gradient(45deg, #A28CE2, #80B0FF)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
        }}
      >
        AI 帮我总结
      </span>
    </div>
  );

  // 当 isPrevent 为 true 时显示 Tooltip，否则只显示按钮
  return isPrevent ? (
    <Tooltip 
      content={<span>本场会记来自于大屏/他人，创建副本到<br />我的会记后，可生成AI总结</span>} 
      hover={true}
      placement="top"
    >
      {buttonElement}
    </Tooltip>
  ) : (
    buttonElement
  );
};

export default GenerateButton;
